<template>
  <a-config-provider :locale="zhCN">
    <router-view></router-view>
  </a-config-provider>
</template>

<script lang="ts" setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { onMounted, reactive, ref } from 'vue';
import { getAllMaps } from './api/common';

onMounted(async () => {
  const MAP = await getAllMaps();
  window.localStorage.setItem('map', JSON.stringify(MAP));
});
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
}

html {
  height: 100vh;
  overflow-y: hidden;
}

body {
  margin: 0;
  height: 100vh;
  overflow-y: hidden;
}

// 修改antd样式
// 全局表格样式
// .ant-table {
//   border-radius: 8px !important;
//   overflow: hidden;
// }

// .ant-table-wrapper {
//   border-radius: 8px !important;
//   overflow: hidden;
// }

// .ant-table-thead .ant-table-cell {
//   background: #272727 !important;
//   color: #fff !important;
// }

// .ant-table-cell::before {
//   width: 0px !important;
// }


.ant-menu {
  border-inline-end: none !important;
}


.text-ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.text-ellipsis-1 {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.text-ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

h1 {
  font-size: 2em !important; /* 32px - 或具体值取决于浏览器的默认样式 */
  font-weight: bold !important;
  margin: 0.67em 0 !important; /* 上下边距为默认的间隔 */
}

h2 {
  font-size: 1.5em !important; /* 24px */
  font-weight: bold !important;
  margin: 0.75em 0 !important; /* 上下边距 */
}

h3 {
  font-size: 1.17em !important; /* 20px */
  font-weight: bold !important;
  margin: 0.83em 0 !important; /* 上下边距 */
}

h4 {
  font-size: 1em !important; /* 16px - 通常和正文一致 */
  font-weight: bold !important;
  margin: 1em 0 !important; /* 上下边距 */
}

h5 {
  font-size: 0.83em !important; /* 13px */
  font-weight: bold !important;
  margin: 1.33em 0 !important; /* 上下边距 */
}

h6 {
  font-size: 0.75em !important; /* 12px */
  font-weight: bold !important;
  margin: 1.67em 0 !important; /* 上下边距 */
}

.ProseMirror:focus-visible {
  outline: none !important;
}

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
  height: 8px; /* 横向滚动条高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  border-radius: 10px; /* 轨道圆角 */
  background-color: transparent;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: linear-gradient(180deg, #cecece, #cecece 100%);
  transition: background 0.3s ease;
}

/* 滑块悬停 */
::-webkit-scrollbar-thumb:hover {
  background: #cecece;
}

/* 滑块点击时 */
::-webkit-scrollbar-thumb:active {
  background: #cecece;
} 


</style>
